var $ca177778f9a74e3c$exports = {};
$ca177778f9a74e3c$exports = {
  "buttonLabel": "\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 ");
      }
    }), " \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0395\u03B9\u03C3\u03B1\u03B3\u03BC\u03AD\u03BD\u03B7 \u03BF\u03BC\u03AC\u03B4\u03B1 ".concat(args.groupTitle, ", \u03BC\u03B5 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u03A0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5");
  }
};
export { $ca177778f9a74e3c$exports as default };